import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Subject } from "rxjs";
import { Route, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardDetailsService {
  url: any = environment.API_URL;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private route: Router
  ) { }

  getCardDetails() {
    return this.http.get(this.url + 'stripe/get/cards');
  }

  deleteCard(cardId: string) {
    return this.http.delete(this.url + 'stripe/delete/card/' + cardId);
  }
}
